// extracted by mini-css-extract-plugin
export default {"bg":"bg--k3Rgc"};